<template>
      <BreadCrumb PageTitle=" Liste des marchands" />

    <ListeUsager/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";

 import ListeUsager from "@/components/Usager/ListeUsager.vue";

    export default defineComponent({
      name: "ListeUsagerPage",
      components: {
        BreadCrumb,
        ListeUsager,
      },
    });
  </script>